import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { getFullNameInitials, randomLinear } from 'src/legacy/utils/helpers';
import Storage from 'src/latest/src/utils/Storage';
import { User } from './types';
import { Photo } from '../Photo/Photo';
import './UserProfileHeader.scss';
import { UserRoles } from '../../constants/UserRoles';
import { Typography } from 'src/latest/src/components';
import { DocumentType } from '../../constants';

type props = {
  userProfileDetails: User;
};

export default function UserAvatar({ userProfileDetails }: props) {
  const { loggedInUser } = useSelector(
    ({ authentication }: any) => authentication,
  );
  const isLoggedinUserAdmin = loggedInUser?.user_type?.includes(
    UserRoles.PRACTICE_ADMIN,
  );
  const isProfileUserClient = userProfileDetails?.user_type?.includes(
    UserRoles.CLIENT,
  );
  const bgLinearFromStorage = Storage.getItem('bgLinear')
    ? Storage.getItem('bgLinear')?.toString()
    : '';

  const isViewingOwnProfile = loggedInUser?.id === userProfileDetails.id;

  const getContent = () => {
    let content;

    if (
      !isProfileUserClient &&
      ((isLoggedinUserAdmin && !isViewingOwnProfile) || isViewingOwnProfile)
    ) {
      content = (
        <>
          <Photo
            userDetails={userProfileDetails}
            documentType={DocumentType.PROFILE_PIC}
            size="m"
          />
        </>
      );
    } else if (userProfileDetails?.profile_pic) {
      content = (
        <img
          src={`${decodeURIComponent(userProfileDetails?.profile_pic)}`}
          alt=""
          className="profile-image"
        />
      );
    } else {
      content = (
        <Typography weight="bold" variant="size-24" className="text-uppercase">
          {userProfileDetails?.full_name &&
          !isEmpty(userProfileDetails?.full_name)
            ? getFullNameInitials(userProfileDetails?.full_name)
            : getFullNameInitials(userProfileDetails.email)}
        </Typography>
      );
    }

    return content;
  };

  return (
    <div
      className="user-content__avatar"
      style={{
        backgroundImage: bgLinearFromStorage || randomLinear(255),
      }}
    >
      {getContent()}
    </div>
  );
}
